import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const getPageNumbers = (page, pageCount) => {
  const delta = 1;
  const range = [];
  const rangeWithDots = [];
  let last;

  for (let i = 1; i <= pageCount; i += 1) {
    if (i === 1 || i === pageCount || (i >= page - delta && i <= page + delta)) {
      range.push(i);
    }
  }

  range.forEach((i) => {
    if (last) {
      if (i - last === 2) {
        rangeWithDots.push(last + 1);
      } else if (i - last > 2) {
        rangeWithDots.push('...');
      }
    }

    rangeWithDots.push(i);
    last = i;
  });

  return rangeWithDots;
};

const AppPagination = ({ page, pageCount, onPageChange, className, showSinglePage }) => {
  if (pageCount <= 1 && !showSinglePage) return null;

  const pages = getPageNumbers(page, pageCount);

  return (
    <Pagination tag="div" className={`modern-pagination mb-0 ${className}`}>
      <PaginationItem disabled={page <= 1}>
        <PaginationLink
          previous
          onClick={() => page > 1 && onPageChange(page - 1)}
        />
      </PaginationItem>

      {pages.map((p, idx) =>
        p === '...' ? (
          // eslint-disable-next-line react/no-array-index-key
          <PaginationItem
  disabled
  key={`dots-${pages.slice(0, idx).join('-')}`}
  className="pagination-dots"
>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem active={p === page} key={p}>
            <PaginationLink onClick={() => onPageChange(p)}>
              {p}
            </PaginationLink>
          </PaginationItem>
        ),
      )}

      <PaginationItem disabled={page >= pageCount}>
        <PaginationLink
          next
          onClick={() => page < pageCount && onPageChange(page + 1)}
        />
      </PaginationItem>
    </Pagination>
  );
};

AppPagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  showSinglePage: PropTypes.bool,
};

AppPagination.defaultProps = {
  className: '',
  showSinglePage: false,
};

export default AppPagination;
